import { MediaGrid } from "./MediaGrid";

interface FavoritesProps {
  isAdmin: boolean;
}

export function Favorites({ isAdmin }: FavoritesProps) {
  return (
    <MediaGrid
      set="favorites"
      isAdmin={isAdmin}
      emptyHint="No favorites yet. Open a media item and click the heart to add it."
    />
  );
}
